<template>
  <div class="modal-overlay">
    <div class="modal-caixa">
      <h2 class="modal-titulo">Selecione seu perfil de acesso</h2>
      <p class="modal-descricao">
        Escolha com qual perfil deseja acessar o Sistema de Avaliação de Servidores.
        Esta escolha será salva e aplicada nos próximos acessos.
      </p>

      <div class="opcoes">
        <button
          class="opcao-btn"
          :class="{ selecionado: perfilSelecionado === 'admin_ti' }"
          @click="perfilSelecionado = 'admin_ti'"
        >
          <strong>{{ perfilPrivilegiado.nome }}</strong>
          <span>{{ perfilPrivilegiado.descricao }}</span>
        </button>

        <button
          class="opcao-btn"
          :class="{ selecionado: perfilSelecionado === 'usuario' }"
          @click="perfilSelecionado = 'usuario'"
        >
          <strong>Usuário</strong>
          <span>Acesso padrão ao sistema</span>
        </button>
      </div>

      <p v-if="erro" class="erro-msg">{{ erro }}</p>

      <button
        class="btn-confirmar"
        :disabled="!perfilSelecionado || salvando"
        @click="confirmar"
      >
        {{ salvando ? 'Aguarde...' : 'Confirmar' }}
      </button>
    </div>
  </div>
</template>

<script>
import PermissaoEscolhaApi from '../services/PermissaoEscolhaApi';
import Auth, { FUNCIONALIDADE_ALTA_GESTAO, FUNCIONALIDADES_ALTA_GESTAO_RESTRITA } from '../services/Auth';

export default {
  name: 'ModalEscolhaPermissao',
  props: {
    perfilAtual: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      perfilSelecionado: this.perfilAtual,
      salvando: false,
      erro: null,
    };
  },
  computed: {
    // A opção 'admin_ti' representa o perfil completo do SGU (Admin TI ou
    // Alta Gestão); o nome exibido acompanha o perfil que o usuário tem.
    perfilPrivilegiado() {
      const funcionalidades = new Auth().usuario?.funcionalidades || [];
      const areas = Object.keys(FUNCIONALIDADES_ALTA_GESTAO_RESTRITA)
        .filter(f => funcionalidades.includes(f))
        .map(f => FUNCIONALIDADES_ALTA_GESTAO_RESTRITA[f]);
      if (areas.length > 0) {
        return {
          nome: `Avaliação - Usuário Alta Gestão ${areas.join(' / ')}`,
          descricao: 'Visualiza as unidades da sua área, sem criar, editar ou excluir',
        };
      }
      if (funcionalidades.includes(FUNCIONALIDADE_ALTA_GESTAO)) {
        return {
          nome: 'Avaliação - Usuário Alta Gestão',
          descricao: 'Visualiza todas as unidades, com as permissões definidas no SGU',
        };
      }
      return {
        nome: 'Avaliação - Admin TI',
        descricao: 'Acesso completo com funcionalidades administrativas',
      };
    },
  },
  methods: {
    async confirmar() {
      if (!this.perfilSelecionado) return;
      this.salvando = true;
      this.erro = null;
      console.log('[Modal.confirmar] perfil selecionado:', this.perfilSelecionado);
      try {
        const api = new PermissaoEscolhaApi();
        const resultado = await api.salvar(this.perfilSelecionado);
        console.log('[Modal.confirmar] resposta do salvar:', resultado);
        this.$emit('perfil-escolhido', this.perfilSelecionado);
        console.log('[Modal.confirmar] evento perfil-escolhido emitido');
      } catch (err) {
        console.error('[Modal.confirmar] erro ao salvar:', err);
        this.erro = 'Não foi possível salvar a escolha. Tente novamente.';
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-caixa {
  background: #fff;
  border-radius: 8px;
  padding: 2rem;
  width: 90%;
  max-width: 480px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.modal-titulo {
  font-family: 'Montserrat-Medium', sans-serif;
  font-size: 1.3rem;
  font-weight: bold;
  color: #1a3a5c;
  margin-bottom: 0.75rem;
}

.modal-descricao {
  font-family: 'Montserrat-Medium', sans-serif;
  font-size: 0.95rem;
  color: #444;
  margin-bottom: 1.5rem;
  line-height: 1.5;
}

.opcoes {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.opcao-btn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  padding: 1rem 1.25rem;
  border: 2px solid #d0d7de;
  border-radius: 6px;
  background: #f8f9fa;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.2s, background 0.2s;

  strong {
    font-family: 'Montserrat-Medium', sans-serif;
    font-size: 1rem;
    color: #1a3a5c;
  }

  span {
    font-family: 'Montserrat-Medium', sans-serif;
    font-size: 0.85rem;
    color: #666;
  }

  &:hover {
    border-color: #139b2b;
    background: #f0faf2;
  }

  &.selecionado {
    border-color: #139b2b;
    background: #e6f7ea;

    strong {
      color: #0a6e1e;
    }
  }
}

.erro-msg {
  color: #c0392b;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  font-family: 'Montserrat-Medium', sans-serif;
}

.btn-confirmar {
  width: 100%;
  padding: 0.85rem;
  background-color: #139b2b;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-family: 'Montserrat-Medium', sans-serif;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover:not(:disabled) {
    background-color: #0a6e1e;
  }

  &:disabled {
    background-color: #a0c8a8;
    cursor: not-allowed;
  }
}
</style>
